import { IEvent } from '@common/nav';
import { NavPageItem } from '@common/navdata';
import { GetGridOptionSettings, INavGrid } from '@common/navkendo/navgrid';
import { IDocLink } from '@common/preview/preview.d';
import * as rwf3 from '@common/rwf';
import { $locationChangeCancel, SessionEvents as FormEvents } from '@common/rwf/rwfedit.common';
import { NavSettingsService } from '@common/services/settingsservice';
import { fn, IInfOperation } from '@common/utils';
import { CompatibilityService } from '@services/compatibilityservice';
import { NavCollapsible } from '../../mobile/controls/navcollapsible';
import { SetUpToggleToolbar } from '../commoncontrols/commoncontrols';
import { getLogConfigColumns } from '../kendo/templates';
import { KWFAppActions } from '../KWFAppActions';
import { KWFFormSession } from '../KWFEdit';
import { IKWFRootScope, IKWFRoute } from '../KWFMain';
import * as kutils from '../navkendo';
import { GetGridOptions } from '../navkendo';
import { NavDock, NavDockZones } from '../navkendo/navdock';
import { RWFPreviewDock } from '../PreviewDock';
import { GetDocGridOptions } from '@rwfangularjs/editform/supplementdocuments/supplementdocuments';

/** KWF Edit Form Controller Function (Used in KWF2 AND KWF 3 Scenario!") */
export class CtrlKWFEdit {
    static Template = require('./editform.html');
    static RouteName = 'kwfEditForm';
    static Route: IKWFRoute = {
        DescriptionFormula: "KWFSession.DisplayMandant",
        TitleFormula: "KWFSession.DocumentTitle",
        resolve: {
            "KWFFormSession": ["CompatibilityService", "$route", function (
                $c: CompatibilityService,
                $route: ng.route.IRouteService): PromiseLike<KWFFormSession> {
                var $routeParams = $route.current.params;
                const isReadonly = $routeParams["readonly"] === "1";
                const instanceId = $routeParams["instanceId"];
                return KWFFormSession.Instantiate($c, instanceId, isReadonly);
            }]
        },
        template: CtrlKWFEdit.Template,
        controller: CtrlKWFEdit,
        name: "Rechnungsworkflow",
        NameFormula : "KWFSession.KWFService.SourceRecordInfos ? 'Freigabeworkflow' : 'Rechnungsworkflow'"
    };
    static $inject = ["$scope", "$window", "$location", "KWFFormSession", "CompatibilityService", "KWFAppActions", "NavSettings"];
    constructor($scope: ng.IScope, $window: ng.IWindowService, $location: ng.ILocationService,
        KWFFormSession: KWFFormSession, $c: CompatibilityService, KWFAppActions: KWFAppActions,
        NavSettings: NavSettingsService) {
        $scope["KWFSession"] = KWFFormSession;

        const userSettings = $scope['usersettings'] = KWFFormSession.UserSettings;

        var toggleState = $c.defer<boolean>();
        var actToggleHoverMenuBar = $scope["actToggleHoverMenuBar"] = SetUpToggleToolbar();

        // Problem : We must match the doem Elements in the rigth Context
        // global JQuery Selectors might catch the "previous" ones when directly switching form one to another EditForm
        var tbInit = $scope.$on("kendoWidgetCreated", (e, w: NavDockZones) => {
            if (w instanceof NavDockZones) {
                tbInit();
                var bar = $("#mainRibbonBarContainer", w.element.parents().last());
                var barContent = $(".tabs-content", bar);
                actToggleHoverMenuBar.Initialize(bar, barContent, toggleState.promise);
            }
        });

        userSettings.Add("MenuToggleState",
            () => { return { Checked: actToggleHoverMenuBar.Checked }; },
            c => {
                if (typeof c.Checked == "boolean")
                    actToggleHoverMenuBar.Checked = c.Checked;
            }
        );

        // setup Change Event for Select action
        $scope["SelectRootRoutingAction"] = (e: kendo.ui.DropDownListChangeEvent) => KWFFormSession.SelectRootRoutingAction(e.sender.dataItem());
        $scope["SelectSubRoutingAction"] = (e: kendo.ui.DropDownListChangeEvent) => KWFFormSession.SelectSubRoutingAction(e.sender.dataItem());
        // Problem Is kendo events are outside of angular request cycle -> trigger
        KWFFormSession.bind(FormEvents.change, $scope.$evalAsync.bind($scope));

        // Mass Open Scenario related functionality
        var mass = $location.search()["mass"];
        if(!mass) {
            KWFAppActions.MyInvoices.MassOpen.Clear()
        }
        var massCancel = $scope["Mass"] = {
            Current : KWFAppActions.MyInvoices.MassOpen.Current,
            Close: {
                Enabled: !!mass,
                Hidden: "Enabled",
                Execute: () => {
                    // Execute regular Close after Clearing mass Execute Queque
                    return KWFAppActions.MyInvoices.MassOpen.Clear().then(() => {
                        return KWFFormSession.EnsureCommit().then(() => KWFFormSession.Close(false));
                    });
                }
            }
        };

        // Navigate back on Destroy of KWF Session if Possible (otherwise Default is Executed : Close Window)
        KWFFormSession.bindWithDefer((e: IEvent) => {
            return $c.when().then(() => {
                if (e.isDefaultPrevented())
                    return;
                var q = $c.when();

                // Check for next mass Open Item
                if (mass) {
                    q = q.then(() => KWFAppActions.MyInvoices.MassOpen.OpenNext()).then(succ => {
                        if (succ) {
                            // Next Mass Item opened
                            e.preventDefault();
                        }
                    });
                }
                return q.then(() => {
                    if (e.isDefaultPrevented())
                        return;
                    // check for explicit set source -> redirect to explicit source
                    var nextUrl = pendingNextLocation || ($location["$$search"] && <string>$location["$$search"].source);

                    let navHistory = (<IKWFRootScope>$scope.$root).NavigationHistory;

                    // Ensure we do not navigate to same URL again
                    if (navHistory && navHistory.length > 0) {
                        var lastUrl = navHistory[navHistory.length - 1],
                            currUrl = $location.url();

                        if (lastUrl == $location.path() || lastUrl == currUrl || lastUrl == decodeURIComponent(currUrl))
                            navHistory.pop();
                    }

                    // No Explicit Next : try move back
                    if (!nextUrl && navHistory && navHistory.length > 0) {
                        nextUrl = navHistory.pop();
                    }

                    // Prevent Default handling (close window) when next url available
                    if (nextUrl) {
                        var isabsolute = (nextUrl.indexOf("http:") == 0 || nextUrl.indexOf("https:") == 0);
                        if (isabsolute) {
                            $window.setTimeout(() => window.location.replace(nextUrl));
                            // Problem : Navigate FROM SPA will not gracefully TearDown Scope etc, ...
                            userSettings.Save();
                        } else {
                            $location.url(nextUrl || "/").replace();
                        }

                        e.preventDefault();
                    }
                });
            });
        }, FormEvents.destroy);
        // Handle Navigation
        $scope.$on("$destroy", NavSettings.RegisterOnBeforeUnload((ev) => {
            if (KWFFormSession && !KWFFormSession.IsDestroyed) {
                var isOpenedReadonly = KWFFormSession.KWFService && KWFFormSession.KWFService.IsCheckedOut === false;
                if (!isOpenedReadonly) {
                    ev.returnValue = "Bitte schliessen sie das Formular über 'Schliessen', 'Zwischenspeichern' oder 'Weiterleiten'";
                    ev.preventDefault();
                }
            }
        }));

        /** Stored Currently pending location Change Target () */
        var pendingNextLocation: string;
        // Handle Route Change : Navigate away only after Explicit Close of session
        var deregister = $scope.$on('$locationChangeStart', function (evt, absNewUrl: string, absOldUrl) {
            if (KWFFormSession && !KWFFormSession.IsDestroyed) {
                pendingNextLocation = absNewUrl.split('#')[1];
                $c.finally<any>(KWFFormSession.EnsureCommit().then(() => KWFFormSession.Close(false)).then(undefined, err => $scope.$root.$broadcast($locationChangeCancel)),
                    () => pendingNextLocation = undefined);
                evt.preventDefault();
            }
        });
        KWFFormSession.bind(FormEvents.destroyed, deregister);
        // restore old onbeforeunload function on scope destroy
        $scope.$on("$destroy", () => {
            KWFFormSession = $scope["KWFSession"] = null;
            deregister();
        });

        /** Set document of preview dock (debounced) */
        function setPreview(doclink?: IDocLink, scrollIntoView?: boolean) {
            let currentPreviewParams = doclink && [doclink["ID"] || "", doclink.Title, doclink.Url, doclink.Extension].join("~");
            let previewChanged = currentPreviewParams != lastPreviewParams;

            if (previewChanged || !lastDebouncedPreview) {
                lastDebouncedPreview = debouncedPreview(doclink, scrollIntoView);
            }
            lastPreviewParams = currentPreviewParams;

            lastDebouncedPreview();
        }
        var lastPreviewParams = null;
        var lastDebouncedPreview = null;

        /** Debounce multiple preview update calls */
        function debouncedPreview(doclink?: IDocLink, scrollIntoView?: boolean) {
            return fn.debounce(() => {
                var kPreviewDock = getPreviewDock();
                if (kPreviewDock) {
                    currentPreviewDoc = doclink || KWFFormSession.KWFService.MainDocLink;
                    currentPreviewDoc.Url = (doclink && doclink.Url) || KWFFormSession.CurrentState.DocLink;

                    // i.e. is not externally dispatched
                    let isDocked = !kPreviewDock.UndockedPreview.IsActive;
                    let isCollapsed = kPreviewDock.IsCollapsed();

                    setPreviewTitle(currentPreviewDoc && currentPreviewDoc.Title);

                    kPreviewDock.SetDocument(currentPreviewDoc);

                    //// Expand preview dock, if collapsed
                    //if (isDocked && isCollapsed) {
                    //    kPreviewDock.Expand(true);
                    //}

                    // Bring preview dock into view
                    if (!!scrollIntoView && isDocked && !isCollapsed && kPreviewDock.element.length > 0) {
                        kPreviewDock.element[0].scrollIntoView();
                    }
                }
            }, 100);
        }

        /** Set preview title of preview dock */
        function setPreviewTitle(name: string) {
            var kPreviewDock = getPreviewDock();
            if (kPreviewDock) {
                kPreviewDock.SetTitle("Vorschau: " + (name != null ? name : "Hauptdokument"));
            }
        }

        // Show preview
        $scope.$on("$previewChange", (e, doclink: { Link: IDocLink }) => setPreview(doclink.Link, true));
        $scope.$on("$previewTitleChange", (e, name) =>
            setPreviewTitle(name)
        );

        // Show preview of main doc
        var initPreviewDock: IDocLink = KWFFormSession.KWFService.MainDocLink,
            currentPreviewDoc = initPreviewDock;

        // Initial dock content (before widget)
        var getPreviewDock = () => resolvedPreviewDock || (resolvedPreviewDock = <RWFPreviewDock>$scope["kwfdock_preview"]);
        var resolvedPreviewDock: RWFPreviewDock = getPreviewDock();
        var waitPreviewDock = $scope.$watch(getPreviewDock, dock => {
            if (dock) {
                waitPreviewDock();

                if (initPreviewDock) {
                    setPreview();
                } else {
                    setPreviewTitle('Keine Dokumente vorhanden');
                }
            }
        });

        // Reset the document of the preview to the main document
        $scope["ResetPreviewCommand"] = {
            Hint: "Zurücksetzen",
            Icon: 'idms_Icon_Reset',
            Execute: () => {
                getPreviewDock().UndockedPreview.IsActive = false;
                setPreview();
            }
        };

        // Preview commands
        $scope["UndockPreviewCommand"] = <IInfOperation & { Hint: string }>{
            Hint: "In separates Fenster abdocken/Abgedocktes Fenster andocken",
            Icon: 'idms_Icon_UnDock',
            Execute: () => {
                getPreviewDock().UndockWindow();
            }
        };

        $scope["DownloadDocCommand"] = <IInfOperation & { Hint: string }>{
            Hint: "Dokument herunterladen",
            Icon: 'idms_Icon_Download',
            Execute: () => {
                window.open(currentPreviewDoc.Url, "_blank");
            }
        };

        var wfInstance = <NavPageItem<rwf3.IFDRW_WFInstance>>KWFFormSession.KWFService["WFInstance"];
        if (wfInstance && !(wfInstance instanceof NavPageItem))
            throw new Error("Expected NavPageItem");

        // Set UP KWF3 Specific UI : Columns and User Presistence
        if (wfInstance) {
            // Workflow Logs
            let metaData = wfInstance.MetaData,
                logEntriesProps = metaData.PropsByName.Workflow_Log_Entries_Sub.ArrayProperties,
                logData = wfInstance.GetValue("Workflow_Log_Entries_Sub");
            var logOptions = GetGridOptions(logData, logEntriesProps, getLogConfigColumns(logEntriesProps));
            logOptions.selectable = 'cell';
            var colMenu: kendo.ui.GridColumnMenu = <kendo.ui.GridColumnMenu>logOptions.columnMenu || (logOptions.columnMenu = {});
            colMenu.filterable = true;
            logOptions.dataBound = e => {
                // Count update
                var dock = <NavDock>$scope["log_dock"];
                if (dock) {
                    dock.SetCountByGrid();
                }
            };
            kutils.UpdateGridOptions(logOptions);

            userSettings.Add("LogGrid", GetGridOptionSettings(logOptions, () => $("#kwf3EditLogGrid").data("kendoGrid")));
            //Set initial filter on type
            let techLogFilter = {
                field: "Type",
                operator: "eq",
                value: 0 // 0 = fachlich
            };
            var logDs = <kendo.data.DataSource>logOptions.dataSource;
            logOptions.filterable = {}; //{ mode: "row" };
            // Action to Toggle the Log Filter
            var actToggleLogFilter = {
                Checked: false,
                Execute: () => {
                    var logDs = <kendo.data.DataSource>logOptions.dataSource;

                    actToggleLogFilter.Checked = !actToggleLogFilter.Checked;
                    if (!actToggleLogFilter.Checked)
                        logDs.filter([]);
                    else
                        logDs.filter([techLogFilter]);
                    actToggleLogFilter.Refresh();
                },
                Icon: { "k-icon" : true, "k-i-filter": false, "k-i-filter-clear": true },
                Hint: "",
                Refresh: () => {
                    var filter = logDs.filter();
                    var checked = actToggleLogFilter.Checked = !!(filter?.filters?.length > 0);
                    actToggleLogFilter.Icon["k-i-filter"] = !actToggleLogFilter.Checked;
                    actToggleLogFilter.Icon["k-i-filter-clear"] = actToggleLogFilter.Checked;
                    actToggleLogFilter.Hint = checked ? "Alle Einträge anzeigen (Filter lösen)" : "Technische Einträge filtern";
                }
            };

            $scope["JournalCommands"] = [actToggleLogFilter];
            actToggleLogFilter.Refresh();

            // Workflow Documents
            var docProperties = wfInstance.MetaData.PropsByName.Workflow_Documents_Sub.ArrayProperties;
            var docData = wfInstance.GetValue("Workflow_Documents_Sub");
            var getDocGrid = () => <INavGrid>$("#kwf3EditDocGrid").data("kendoNavGrid");
            // As we byPass Standard kendo Model Functionality, we have to Manully refresh on Value Change ...
            $scope.$on("$destroy", wfInstance.RegisterPropertyChanged("Workflow_Documents_Sub", (ev) => {
                var grid = getDocGrid();
                if (grid && $.isFunction(grid.refreshFromModel))
                    grid.refreshFromModel(ev.Item.Model, ev.Prop.Name);
            }));

            var hideEditCols = KWFFormSession && KWFFormSession.CurrentState && KWFFormSession.CurrentState.CurrentStepReadOnly;
            var docOptions = GetDocGridOptions(docData, docProperties, hideEditCols);

            docOptions.dataBound = e => {
                // Count update
                var dock = <NavDock | NavCollapsible >$scope["supdoc_dock"];
                if (dock) {
                    dock.SetCountByGrid();
                    $scope.$on("$destroy", wfInstance.RegisterPropertyChanged("Workflow_Documents_Sub", () => dock.SetCountByGrid()));
                }
            };
            kutils.UpdateGridOptions(docOptions);
            userSettings.Add("DocGrid", GetGridOptionSettings(docOptions, getDocGrid));
        }

        const afterLoad = () => {
            if (docOptions) {
                $scope["DocOptions"] = docOptions;
                $scope["LogOptions"] = logOptions;
            }

            toggleState.resolve(actToggleHoverMenuBar.Checked);
        };
        // SetUp User Persistence for DocGrid/LogGrid
        userSettings.Load().then(afterLoad, afterLoad);
        // Store Current Settings on Destruction of Scope
        $scope.$on("$destroy", () => userSettings.Save());
    };
}
